import React from 'react';
import { FiCalendar } from 'react-icons/fi';

const toParts = (value) => {
  if (!value || typeof value !== 'string') return { date: '', hour: '00', minute: '00' };
  const [datePart, timePart] = value.split('T');
  const date = datePart || '';
  let hour = '00';
  let minute = '00';
  if (timePart) {
    const [h, m] = timePart.split(':');
    if (h !== undefined) hour = h.padStart(2, '0');
    if (m !== undefined) minute = m.padStart(2, '0');
  }
  return { date, hour, minute };
};

const fromParts = (date, hour, minute) => {
  if (!date) return '';
  const h = String(hour).padStart(2, '0');
  const m = String(minute).padStart(2, '0');
  return `${date}T${h}:${m}`;
};

const hours = Array.from({ length: 24 }, (_, i) => i);
const minutes = Array.from({ length: 60 }, (_, i) => i);

const DateTime24Input = ({ value, onChange, id, name, className = '', required, disabled, showCalendarIcon = true }) => {
  const { date, hour, minute } = toParts(value);
  const baseClass = 'px-3 py-2 bg-background border border-dark-300 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-purple-300';

  const handleDateChange = (e) => {
    onChange(fromParts(e.target.value, hour, minute));
  };
  const handleHourChange = (e) => {
    onChange(fromParts(date, e.target.value, minute));
  };
  const handleMinuteChange = (e) => {
    onChange(fromParts(date, hour, e.target.value));
  };

  return (
    <div className={`datetime24-input flex flex-wrap items-center gap-2 ${className}`}>
      <style>{`
        .datetime24-input input[type="date"]::-webkit-calendar-picker-indicator {
          filter: invert(1);
          cursor: pointer;
          opacity: 0.9;
        }
      `}</style>
      <div className="relative flex-1 min-w-0 flex items-center gap-2 rounded-lg border border-dark-300 bg-background focus-within:ring-2 focus-within:ring-purple-300 pl-2">
        {showCalendarIcon && (
          <FiCalendar className="shrink-0 text-white" size={18} aria-hidden />
        )}
        <input
          type="date"
          id={id}
          name={name ? `${name}_date` : undefined}
          value={date}
          onChange={handleDateChange}
          required={required}
          disabled={disabled}
          className={`${baseClass} flex-1 min-w-0 border-0 focus:ring-0 bg-transparent`}
        />
      </div>
      <select
        aria-label="Hour (24h)"
        value={hour}
        onChange={handleHourChange}
        disabled={disabled}
        className={`${baseClass} w-[72px]`}
      >
        {hours.map((h) => (
          <option key={h} value={String(h).padStart(2, '0')}>
            {String(h).padStart(2, '0')}
          </option>
        ))}
      </select>
      <span className="text-dark-100 font-medium">:</span>
      <select
        aria-label="Minute"
        value={minute}
        onChange={handleMinuteChange}
        disabled={disabled}
        className={`${baseClass} w-[72px]`}
      >
        {minutes.map((m) => (
          <option key={m} value={String(m).padStart(2, '0')}>
            {String(m).padStart(2, '0')}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DateTime24Input;
